import { i18n } from '@/i18n/i18n';

import { Button } from '../design-system/Button';
import ShiplexLogo from './ShiplexLogo';

interface ErrorScreenProps {
  onTryAgain: () => void;
  onReturnToDashboard: () => void;
}

export const ErrorScreen = ({ onTryAgain, onReturnToDashboard }: ErrorScreenProps) => {
  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <div className="absolute top-4 left-4">
        <ShiplexLogo color="darkBlue" />
      </div>

      <div className="flex flex-col items-center space-y-6 text-center">
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-primary text-5xl font-semibold">{i18n.t('error.errorBoundary.title')}</h1>
          <p className="pt-12 text-lg text-black/65">{i18n.t('error.errorBoundary.message')}</p>
          <p className="pb-12 text-lg text-black/65">{i18n.t('error.errorBoundary.instruction')}</p>
        </div>

        <div className="flex gap-3">
          <Button
            onClick={onTryAgain}
            variant="outline"
            className="text-primary hover:bg-primary hover:text-typography border-primary h-10 rounded-md border px-6 text-base font-medium shadow-sm transition-all duration-200"
          >
            {i18n.t('error.errorBoundary.tryAgain')}
          </Button>
          <Button
            onClick={onReturnToDashboard}
            className="bg-primary border-primary text-typography hover:bg-primary/90 hover:text-typography/90 h-10 rounded-md border px-6 text-base font-medium shadow-sm transition"
          >
            {i18n.t('error.errorBoundary.returnToDashboard')}
          </Button>
        </div>
      </div>
    </div>
  );
};
